import {GET, POST} from "@/services/gateway";

const list = ({pagination, search, filter}) => {
  return POST('seat/user/list', {pagination, search, filter});
}

const getStatus = () => {
  return GET('seat/user/status');
}

const refresh = () => {
  return GET('seat/user/refresh');
}

const backupAll = () => {
  return GET('seat/user/backup')
}

const protectAll = () => {
  return POST('seat/user/protect');
}


const unprotectAll = () => {
  return POST('seat/user/unprotect');
}

const changeStatus = ({status, id}) => {
  return POST('seat/userstatus/change', {status, id});
}

const exportSnapshot = (filter, search, pagination) => {
  const currentDate = new Date();

  return POST('seat/user/export', {filter, search, pagination, TimeZoneOffset: currentDate.getTimezoneOffset()})
}

export {
  list,
  refresh,
  getStatus,
  protectAll,
  unprotectAll,
  backupAll,
  changeStatus,
  exportSnapshot
}
